import { render, staticRenderFns } from "./surveyReview.component.vue?vue&type=template&id=2fa0fad2&scoped=true&"
import script from "./surveyReview.component.vue?vue&type=script&lang=js&"
export * from "./surveyReview.component.vue?vue&type=script&lang=js&"
import style0 from "./surveyReview.component.vue?vue&type=style&index=0&id=2fa0fad2&lang=scss&scoped=true&"
import style1 from "./surveyReview.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa0fad2",
  null
  
)

export default component.exports